export const FETCH_APPS_SUCCESS = "FETCH_APPS_SUCCESS";
export const FETCH_APPS_FAILURE = "FETCH_APPS_FAILURE";
export const FETCH_DEPLOYMENT_TYPES_SUCCESS = "FETCH_DEPLOYMENT_TYPES_SUCCESS";
export const FETCH_DEPLOYMENT_TYPES_FAILURE = "FETCH_DEPLOYMENT_TYPES_FAILURE";
export const SET_SELECTED_APP = "SET_SELECTED_APP";
export const SET_SELECTED_DEPLOYMENT_TYPE = "SET_SELECTED_DEPLOYMENT_TYPE";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_SAVE_CREDENTIALS = "SET_SAVE_CREDENTIALS";
export const SET_FORM_ERRORS = "SET_FORM_ERRORS";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const RESET_FORM = "RESET_FORM";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";
